export const GET_SELECTED_CORPORATE = "GET_SELECTED_CORPORATE";
export const GET_SELECTED_SUPERCORPORATE = "GET_SELECTED_SUPERCORPORATE";
export const GET_BULK_PAYMENT_INFO = "GET_BULK_PAYMENT_INFO";
